import { TemplateControlType } from 'src/app/modules/management/store/communication-center';
import { SettingsWrapperControl } from './settings-wrapper-control';
import { DesignControl } from './design-control';
import { TemplateControlService } from './template-control.service';
import { file } from 'jszip';

const displayControlTemplate = `
<div style="margin-bottom: 8px">
  <img class="image-control" src="https://files.topo.ai/images/email/email-header-sit-report.png" style="max-width:800px;" />
</div>
`;
const settingsControlTemplate = `
<div class="upload-edit-control"
  style="
    margin: 4px;border: 3px dashed var(--neutral-color-400);
    background-color:var(--neutral-color-100);cursor:pointer;
    display:flex;
    flex-direction:row;
    align-items:center;
    justify-content:center;
    height:100px;"
>
  <div style="margin-right:0.5rem;"><i class="icon icon-cloud_upload" style="font-size:24px;"></i></div>
  <div>Upload File</div>
  <input class="upload-file-control" type="file" accept="image/*"  style="display: none" />
</div>
`;

export class ImageControl extends DesignControl {
  editSettingsControl: HTMLElement;
  settingsWrapperControl: SettingsWrapperControl;

  constructor(document: Document, templateControlService: TemplateControlService) {
    super(document, templateControlService);

    this.controlTemplate = displayControlTemplate;
    this.settingsTemplate = settingsControlTemplate;
    this.controlType = TemplateControlType.Image;
    this.settingsWrapperControl = this.templateControlService.settingsWrapperControl;
  }

  public edit(): void {
    const sectionHeaderValue = this.controlElement.firstElementChild.textContent.trim();

    this.editSettingsControl = this.document.createElement('div');
    this.editSettingsControl.innerHTML = this.settingsTemplate;

    this.settingsWrapperControl.setContent(this.editSettingsControl);
    this.controlElement.style.display = 'none';

    const uploadEditControl = this.editSettingsControl.getElementsByClassName('upload-edit-control')[0] as HTMLElement;
    uploadEditControl.onclick = this.fileClick.bind(this);

    const uploadFileControl = this.editSettingsControl.getElementsByClassName('upload-file-control')[0] as HTMLInputElement;
    uploadFileControl.onchange = this.fileControlChanged.bind(this);
  }

  public cancel(): void {
    this.settingsWrapperControl.clearContent();
    this.editSettingsControl = null;
    this.controlElement.style.display = 'block';
  }

  public save(): void {
    this.settingsWrapperControl.clearContent();
    this.editSettingsControl = null;
    this.controlElement.style.display = 'block';
  }

  public copy(): void {}

  fileClick(): void {
    const uploadFileControl = this.editSettingsControl.getElementsByClassName('upload-file-control')[0] as HTMLInputElement;
    uploadFileControl.click();
  }

  fileControlChanged($event) {
    $event.preventDefault();
    $event.stopPropagation();

    const files: FileList = $event.target.files;
    const file = files.length > 0 ? files[0] : null;
    const imageControl = this.controlElement.getElementsByClassName('image-control')[0] as HTMLImageElement;

    if (!!file) {
      const reader = new FileReader();

      reader.addEventListener(
        'load',
        () => {
          // convert image file to base64 string
          const imageData = reader.result as string;
          imageControl.src = imageData;

          this.settingsWrapperControl.cancel();
        },
        false
      );

      reader.readAsDataURL(file);
    }
  }
}
